import { render, staticRenderFns } from "./VantLead.vue?vue&type=template&id=13864450&scoped=true&"
import script from "./VantLead.vue?vue&type=script&lang=js&"
export * from "./VantLead.vue?vue&type=script&lang=js&"
import style0 from "./VantLead.vue?vue&type=style&index=0&id=13864450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13864450",
  null
  
)

export default component.exports